import type { AggregationLevel, EnergyTypes } from '~/types/new/energy';
import { defineStore } from 'pinia';
import dayjs from 'dayjs';

export const exploreStore = defineStore('exploreStore', () => {
  // State
  const loading = ref<boolean>(false);
  const areaId = ref<number>(0);
  const period = ref<{ start: string; end: string }>({
    start: dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm'),
    end: dayjs().startOf('day').format('YYYY-MM-DD HH:mm'),
  });
  const energyType = ref<EnergyTypes>('Electricity');
  const showTemperature = ref<boolean>(false);
  const tab = ref<string>('line-chart');
  const aggregationLevel = ref<AggregationLevel>('day');

  // Getters
  const getMeterId = computed(() => {
    const currentAreaId = areaId.value;
    if (currentAreaId === null) return undefined;

    const area = areaStore().getArea(currentAreaId);
    return area?.meters.find((meter: any) => meter.meter_type.energy_type === energyType.value)?.id;
  });

  // Actions
  const setLoading = (value: boolean) => {
    loading.value = value;
  };

  const setAreaId = (value: number) => {
    areaId.value = value;
  };

  const setPeriod = (value: { start: string; end: string }) => {
    period.value = value;
  };

  const setEnergyType = (value: EnergyTypes) => {
    energyType.value = value;
  };

  const setShowTemperature = (value: boolean) => {
    showTemperature.value = value;
  };

  const setTab = (value: string) => {
    tab.value = value;
  };

  const setAggregationLevel = (value: AggregationLevel) => {
    aggregationLevel.value = value;
  };

  // ==================== Lifecycle ====================
  onBeforeMount(async () => {
    const area = areaStore().getAreas[0];
    if (area) {
      areaId.value = area.id;
      energyType.value = area.meters[0]?.meter_type.energy_type ?? 'Electricity';
      period.value = {
        start: dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm'),
        end: dayjs().startOf('day').format('YYYY-MM-DD HH:mm'),
      };
      aggregationLevel.value = 'day';
    }
  });

  return {
    // State
    loading,
    areaId,
    period,
    energyType,
    showTemperature,
    tab,
    aggregationLevel,

    // Getters
    getMeterId,

    // Actions
    setLoading,
    setAreaId,
    setPeriod,
    setEnergyType,
    setShowTemperature,
    setTab,
    setAggregationLevel,
  };
});
